import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useReviewComment() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  async function addReply({ _id, ...data } = {}) {
    return privateFetch.post(`/v1/admin/comments/${_id}`, data).then((res) => res.data);
  }

  async function updateReply({ _id, ...data } = {}) {
    return privateFetch.put(`/v1/admin/comments/${_id}/reply`, data).then((res) => res.data);
  }

  async function deleteReply({ _id, configs = {} } = {}) {
    return privateFetch.delete(`/v1/admin/comments/${_id}/reply`, configs).then((res) => res.data);
  }

  function manageReviews({ type, ...data } = {}) {
    if (type === 'UPDATE') {
      return updateReply(data);
    }
    if (type === 'DELETE') {
      return deleteReply(data);
    }

    return addReply(data);
  }

  return useMutation(manageReviews, {
    onSettled(data, error, variables) {
      if (!variables?.hasBlochHashComment) queryClient.invalidateQueries('content-comments');
      queryClient.invalidateQueries('chapter-mindmap');
    },
  });
}

export default useReviewComment;
